<input #addressInput
       class="form-control"
       type="text"
       [placeholder]="placeholder || ''"
       [disabled]="disabled"
       [readonly]="readonly"
       [ngClass]="{ '-invalid': customError || missing_address }"
       [(ngModel)]="value"
       (ngModelChange)="addressUpdated()">
